import "./MainSourceExterne.scss";
import { Wizard } from "../../../../components/wizard/Wizard";
import { InfoGeneral } from "./InfoGeneral";
import { Source } from "./Source";
import { Stockage } from "./Stockage";
import { Ingestion } from "./Ingestion";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import { resetCdsSlice, setSource, StorageSpaceTypes } from "../../cdsSlice";
import { useLazyViewSourceQuery } from "../../cdsApiSlice";
import { Skeleton } from "primereact/skeleton";
import { MetaData } from "./metadata";
import RenderLoading from "./RendorLoading";
import useGetMetaDataValue from "./common/getMetaDataValue";
import useGetCustomMetaDataWithOrganisme from "./common/getCustomMetaDataWithOrganisme";
import ErrorSourceExterne from "./ErrorSourceExterne";
import { useTranslation } from "react-i18next";
import { useLabelsSelectors } from '@kosmos/shared';

export const MainSourceExterne = () => {
  const { t } = useTranslation();
  const wizard = [
    "Informations générales",
    "Source",
    "Espace de stockage",
    "Ingestion",
  ];
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const { id } = useParams();
    const { labels } = useLabelsSelectors();
  const dispatch = useAppDispatch();
  const { findMetaDataVariable } = useGetMetaDataValue();
  const { getCustomMetaDataWithOrganisme } = useGetCustomMetaDataWithOrganisme();
  const navigate = useNavigate();
  const defaultCustomData: string[] = [
    "source_motif_noms_fichiers",
    "source_recursif",
    "source_http_methode",
    "source_jdbc_requete",
    "source_protocole",
    "source_uri",
    "source_utilisateur",
    "source_type_donnee",
    "source_format_donnee",
    "source_famille",
    "source_organisme",
  ];
  const [getSource, { data: sourceData, ...sourceStatus }] =
      useLazyViewSourceQuery();

  const title = (): string => {
    if (id) {
      return "Modifier une source";
    }
    return "Nouvelle source";
  };

  const path = (): string => {
    if (id) {
      if (sourceData) return sourceData.source.nom;
      return "";
    }
    return "Nouvelle source";
  };

  const viewForm = (): boolean => {
    if (!id) return true;
    return !!sourceData;
  };

  useEffect(() => {
    if (id) {
      getSource({ id: parseInt(id) });
    }
  }, [id]);

  useEffect(() => {
    return () => {
      dispatch(resetCdsSlice());
    }
  },[])

  useEffect(() => {
    if (sourceData) {
      let espaceDeStockage = null;
      let choiceEspaceDeStockage = StorageSpaceTypes.S3;
      if (sourceData.source.espacesDeStockage[0]) {
        choiceEspaceDeStockage = sourceData.source.espacesDeStockage[0].type.toLocaleLowerCase() === StorageSpaceTypes.S3.toLocaleLowerCase()
              ? StorageSpaceTypes.S3
              : StorageSpaceTypes.KAFKA
        espaceDeStockage = sourceData.source.espacesDeStockage[0];
      }

      const metadatasAndLabels = getCustomMetaDataWithOrganisme(
          sourceData.source,
          defaultCustomData,
          labels ?? []
      );

      dispatch(
        setSource({
          id: sourceData.source.id,
          domaine: {
            id: sourceData.source.domaine.id,
            nom: sourceData.source.domaine.libelle,
          },
          nom: sourceData.source.nom,
          description: sourceData.source.description,
          protocole: findMetaDataVariable(
            "source_protocole",
            sourceData.source
          ),
          uri: findMetaDataVariable("source_uri", sourceData.source),
          utilisateur: findMetaDataVariable(
            "source_utilisateur",
            sourceData.source
          ),
          motDePasse: "",
          organisme: findMetaDataVariable(
            "source_organisme",
            sourceData.source
          ),
          typeDeDonnee: {
            name: findMetaDataVariable("source_type_donnee", sourceData.source),
          },
          formatDeDonnee: {
            name: findMetaDataVariable(
              "source_format_donnee",
              sourceData.source
            ),
          },
          CustomMetaData: metadatasAndLabels.customMedatas,
          selectedLabels: metadatasAndLabels.labels,
          espaceDeStockageName: espaceDeStockage ? espaceDeStockage.nom : null,
          sas: sourceData.source.sas,
          choiceEspaceDeStockage: choiceEspaceDeStockage,
          protocoleDatas: MetaData(sourceData),
          espaceDeStockage: espaceDeStockage,
        })
      );
    }
  }, [sourceData]);

  return (
    <>
      <div className="workspaceSourceExterne">
        <div className="toolbarSourceExterne">
          <h2 className="ml-5">{title()}</h2>
          <div className="ml-5 mt-2 mb-2 flex filAriane">
            <div
              onClick={() => navigate("/library/sources")}
              className="mr-2 cursor-pointer"
            >
              {t("title.data-catalog.sources")}
            </div>
            <i
              style={{ color: "#6c757d" }}
              className="pi pi-chevron-right mr-2"
            ></i>{" "}
            {path() ? (
              path()
            ) : sourceStatus.isLoading ? (
              <Skeleton className="ml-2" width="4rem" height="1rem" />
            ) : null}{" "}
          </div>
        </div>
        <div className="wizard">
          <Wizard activeIndex={activeIndex} names={wizard} />
        </div>
        {viewForm() && activeIndex === 0 ? (
          <InfoGeneral
            add={() => {
              setActiveIndex((prev) => prev + 1);
            }}
          />
        ) : (
          ""
        )}
        {viewForm() && activeIndex === 1 ? (
          <Source
            add={() => {
              setActiveIndex((prev) => prev + 1);
            }}
            minus={() => {
              setActiveIndex((prev) => prev - 1);
            }}
          />
        ) : (
          ""
        )}
        {viewForm() && activeIndex === 2 ? (
          <Stockage
            add={() => {
              setActiveIndex((prev) => prev + 1);
            }}
            minus={() => {
              setActiveIndex((prev) => prev - 1);
            }}
          />
        ) : (
          ""
        )}
        {viewForm() && activeIndex === 3 ? (
          <Ingestion
            minus={() => {
              setActiveIndex((prev) => prev - 1);
            }}
          />
        ) : (
          ""
        )}
        {sourceStatus.isLoading ? (
          <>
            <div className="contentForm">
              <div className="formSourceExt mr-5">{RenderLoading(10)}</div>
            </div>
          </>
        ) : (
          ""
        )}
        {sourceStatus.error && !sourceStatus.isLoading && (
          <ErrorSourceExterne message={"Erreur de chargement"} />
        )}
      </div>
    </>
  );
};
